<ng-template #content let-modal>
  <div class="modal-body m-auto">
    <div class="custom-dropdown-menu">
      <a
        class="drop-item"
        *ngFor="let lang of availableLanguages"
        (click)="selLang(lang.code)">
        <img src="{{ lang.img }}" class="w-20 rounded mx-2" />
        {{ lang.name }}
      </a>
    </div>
  </div>
</ng-template>

<button
  class="btn"
  [ngClass]="{ 'p-0 b-none': !style, border: style }"
  type="button"
  (click)="open(content)">
  <img
    *ngIf="getLanguageName(selectedLanguage)?.img"
    [src]="getLanguageName(selectedLanguage)?.img"
    class="w-20 rounded mx-2" />
  <span *ngIf="showName">{{ getLanguageName(selectedLanguage)?.name }}</span>
</button>